/*
 * The first day of the week, by language (F-198, objection 7; F-194 uses it too): Sunday in pt-BR,
 * en-US, es and fr-CA; Monday in de, it, fr and pt-PT. Days are `YYYY-MM-DD` keys, computed in UTC so the
 * browser's zone never shifts them.
 */

/** 0 = Sunday, 1 = Monday. */
export type WeekStartsOn = 0 | 1

const MONDAY_LANGUAGES = ['de', 'it', 'fr']
const MONDAY_LOCALES = ['pt-PT']
/* French Canada counts the week from Sunday, unlike the rest of French. */
const SUNDAY_LOCALES = ['fr-CA']

export const weekStartsOn = (locale: string | undefined | null): WeekStartsOn => {
  const value = (locale || '').trim()
  if (MONDAY_LOCALES.some((l) => l.toLowerCase() === value.toLowerCase())) return 1
  if (SUNDAY_LOCALES.some((l) => l.toLowerCase() === value.toLowerCase())) return 0
  return MONDAY_LANGUAGES.includes(value.slice(0, 2).toLowerCase()) ? 1 : 0
}

export const addDaysKey = (key: string, days: number): string => {
  const [y, m, d] = key.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10)
}

/** Day of the week of a key: 0 = Sunday. */
export const dayOfWeek = (key: string): number => {
  const [y, m, d] = key.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay()
}

/** The first day of the week the day falls in. */
export const weekStart = (key: string, startsOn: WeekStartsOn = 1): string =>
  addDaysKey(key, -((dayOfWeek(key) - startsOn + 7) % 7))
